import { h, Component } from 'preact';
import style from './style';

import {
  loadJS,
  loadCSS,
  sortCollectionsMedia,
  parseJsonToFormData,
  getEngagements,
  getTagPreviewImage,
} from '../helper';
import { links } from './../config';
import GalleryImage from '../spareparts/galleryImage';

const HEAD = document.getElementsByTagName('head')[0];

const swiperCSS = links.swiperCSS;
const swiperJS = links.swiperJS;

export default class SkinV3ProductShowcase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      engagements: getEngagements(this.props.tag),
      showcaseInactive: true,
    };
  }

  componentDidMount() {
    this.checkForSwiper().then(() => {
      setTimeout(() => {
        this.initializeSwiper(this.swiperContainer);
        this.handleClick(0);
        console.log('did mount');
        const isCollectionsTag = this.checkForCollectionType();
        if (isCollectionsTag) {
          this.updateEngagement(0);
        }
      }, 0);
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.tag &&
      nextProps.tag.id &&
      nextProps.tag.id !== this.props.tag.id
    ) {
      const isCollectionsTag = this.checkForCollectionType(nextProps);
      if (isCollectionsTag) {
        this.updateEngagement(0, nextProps);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (this.props.isExpanded !== prevProps.isExpanded &&
        this.props.isExpanded &&
        this.props.isActiveSlide) ||
      (this.props.isExpanded &&
        this.props.isActiveSlide &&
        this.props.isActiveSlide !== prevProps.isActiveSlide) ||
      (this.props.tag && this.props.tag.id) !==
        (prevProps.tag && prevProps.tag.id)
    ) {
      setTimeout(() => {
        this.initializeSwiper(this.swiperContainer);
        this.handleClick(0);
        console.log('did update');
      }, 0);
    }
  }

  componentWillUnmount() {
    if (this.swiper) {
      this.swiper.destroy();
      console.log('did unmount');
    }
  }

  getImageCount = (images) => {
    let hook = images;
    let i = 1;
    let count = 0;

    while (hook && hook[`img${i}_src`]) {
      count = i;
      i++;
    }

    return count;
  };

  getSlides = () => {
    const tag = this.props.tag;
    const isCollectionsTag = this.checkForCollectionType(); // Commerce Purchase type---
    let ele;
    if (!isCollectionsTag) {
      const images = tag && tag.media && tag.media.images;
      const imageCount = this.getImageCount(images);
      ele = [];
      for (let i = 0; i < imageCount; i++) {
        ele.push(<GalleryImage images={images} index={i} />);
      }
    } else {
      // For Collections---
      const attributes = (tag && tag.details && tag.details.attributes) || [];
      const products = sortCollectionsMedia(attributes);
      const tagThemeColor =
        (tag && tag.details && tag.details.color) || '#34b0e8';
      const tagTextColor =
        (this.props.customTagParams && this.props.customTagParams.textColor) ||
        '#454463';
      const tagEngagements = this.state.engagements;
      const tagEngagement = tagEngagements && tagEngagements[0];
      const slug = tagEngagement && tagEngagement.slug;
      const tagCta = tagEngagement && tagEngagement[`label|${slug}`];
      ele = products.map((prod, idx) => {
        const images = prod && prod.media && prod.media.images;
        // const imageCount = this.getImageCount(images);
        const prodTitle = prod && prod.details && prod.details.title;
        const product_id = prod && prod.id;
        const engagement_data = parseJsonToFormData({
          product_id,
          product_label: prodTitle,
        });
        return (
          <div class="swiper-slide">
            <div class={`${style.imagesWrapper} ${style.collections}`}>
              <GalleryImage images={images} index={0} />
              <div class={style.footer}>
                <div
                  class={style.tagTitle}
                  style={{ color: tagTextColor }}
                  dangerouslySetInnerHTML={{ __html: prodTitle }}
                />
                <div
                  class={style.ctaBtn}
                  style={{
                    backgroundColor: tagThemeColor,
                  }}
                  onClick={(e) =>
                    this.props.onCommerceCtaClick(e, { engagement_data })
                  }
                >
                  <span dangerouslySetInnerHTML={{ __html: tagCta }} />
                  <div
                    class={style.shadow}
                    style={{ boxShadow: `0 10px 20px -8px ${tagThemeColor}` }}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      });
    }
    return ele;
  };

  handleHideShowcase = () => {
    this.setState({ showcaseInactive: true });
  };

  handleShowShowcase = () => {
    this.setState({ showcaseInactive: false });
  };

  render(props, state) {
    const swiperContainerStyle = {
      height: '100%',
    };

    const settings = props.tag && props.tag.settings;
    const category = settings.category;
    const subcategory =
      settings.subcategory &&
      settings.subcategory[0] &&
      settings.subcategory[0].type;
    const isCommerceCollections = category === 1 && subcategory !== 106;
    // show commerce/collections tags only---
    if (!isCommerceCollections) {
      return null;
    }

    const slides = this.getSlides() || [];
    const isNonCollection = category === 1 && subcategory !== 105;
    const tagThemeColor =
      (props.tag && props.tag.details && props.tag.details.color) || '#34b0e8';
    const tagTextColor =
      (props.customTagParams && props.customTagParams.textColor) || '#454463';

    const tagTitle =
      (props.tag && props.tag.details && props.tag.details.title) || '';
    const selectedTagEngagements = getEngagements(props.tag);
    const selectedTagEngagement =
      selectedTagEngagements && selectedTagEngagements[0];

    const slug = selectedTagEngagement && selectedTagEngagement.slug;
    const selectedTagCta =
      selectedTagEngagement && selectedTagEngagement[`label|${slug}`];

    // meta key to enable feature for the product showcase sliding effect---xiaomi
    const showcaseSlide = props.meta && props.meta.showcase_tag_cta;
    const iconImg =
      getTagPreviewImage(props.tag, '120') ||
      getTagPreviewImage(props.tag, 'src');

    return (
      <div>
        <div
          class={`${style.productShowcaseWrapper} ${
            showcaseSlide && state.showcaseInactive ? style.inactive : ''
          } ${!isNonCollection ? style.collections : ''} ${
            style[props.orientation]
          }`}
        >
          <div
            class={`${style.imagesWrapper} ${
              !isNonCollection ? style.collections : ''
            }`}
          >
            <div
              ref={(node) => (this.swiperContainer = node)}
              class={'swiper-container swiperHook gallery-swiper'}
              style={swiperContainerStyle}
            >
              <div
                class={`swiper-wrapper ${
                  props.images && props.images.length < 1 ? 'nodata' : ''
                }`}
              >
                {slides}
              </div>
              <div class={'swiper-pagination'} />
            </div>

            {slides.length === 0 ? null : (
              <div
                class={`${
                  style.swiperArrowBtn
                } swiper-button-prev fsImg-prev zmdi ${
                  this.state.isBeginning ? 'swiper-button-disable' : ''
                }`}
                ref={(c) => (this.swiperNavBtnPrev = c)}
                onClick={this.prevSlide}
              />
            )}
            {slides.length === 0 ? null : (
              <div
                class={`${
                  style.swiperArrowBtn
                } swiper-button-next fsImg-next zmdi ${
                  this.state.isEnd ? 'swiper-button-disable' : ''
                }`}
                ref={(c) => (this.swiperNavBtnNext = c)}
                onClick={this.nextSlide}
              />
            )}
          </div>
          {isNonCollection && (
            <div class={style.footer}>
              <div
                class={style.tagTitle}
                style={{ color: tagTextColor }}
                dangerouslySetInnerHTML={{ __html: tagTitle }}
              />
              <div
                class={style.ctaBtn}
                style={{
                  backgroundColor: tagThemeColor,
                }}
                onClick={this.props.onCommerceCtaClick}
              >
                <span dangerouslySetInnerHTML={{ __html: selectedTagCta }} />
                <div
                  class={style.shadow}
                  style={{ boxShadow: `0px 18px 20px -6px ${tagThemeColor}` }}
                />
              </div>
            </div>
          )}
        </div>
        {showcaseSlide && state.showcaseInactive && (
          <div
            class={style.showcaseIconWrapper}
            onClick={this.handleShowShowcase}
          >
            <div class={style.showcaseIcon}>
              <img src={iconImg} alt="" />
            </div>
          </div>
        )}
        {showcaseSlide && !state.showcaseInactive && (
          <div class={style.closeBtnWrapper} onClick={this.handleHideShowcase}>
            <i class="zmdi zmdi-close" />
          </div>
        )}
      </div>
    );
  }

  checkForCollectionType = (props = this.props) => {
    const settings = props.tag && props.tag.settings;
    const category = settings.category;
    const subcategory =
      settings.subcategory &&
      settings.subcategory[0] &&
      settings.subcategory[0].type;

    const isNonCollection = category === 1 && subcategory !== 105;
    return !isNonCollection;
  };

  updateEngagement = (index, props = this.props) => {
    const tag = props.tag;
    const attributes = (tag && tag.details && tag.details.attributes) || [];
    const products = sortCollectionsMedia(attributes);
    const currProd = products && products[index];
    const engagement_id = currProd && currProd.id;
    const variants = currProd && currProd.variants;
    if (!(variants && variants.length > 0)) {
      let tagEngagements = getEngagements(props.tag);
      let engagement = tagEngagements && tagEngagements[0];
      let url =
        (currProd && currProd.details && currProd.details.cta) ||
        (engagement && engagement[`value|${engagement.slug}`]);
      const engagements = [
        { ...engagement, [`value|${engagement.slug}`]: url, id: engagement_id },
      ];
      this.setState({ engagements }, () => {
        const updatedTag = {
          ...tag,
          settings: {
            ...tag.settings,
            subcategory: [{ ...tag.settings.subcategory[0], engagements }],
          },
        };
        props.refreshSkinLayout(updatedTag);
      });
    }
  };

  handleClick = (index, e) => {
    this.setState(
      {
        activeIndex: index,
        selectedImage: index,
      },
      () => {
        if (this.props.isFacebookAd && !this.props.isExpanded) {
          if (this.props.isFacebookAd && this.state.selectedImage !== 0) {
            this.initializeSwiper();
          }
          this.swiper.slideTo(this.state.selectedImage, 300);
          this.handleSlideChange();
        }
      }
    );
    e && e.stopPropagation();
  };

  logCollectionsEvent = (prodIndex) => {
    const products =
      this.props.tag &&
      this.props.tag.details &&
      this.props.tag.details.attributes;
    const product = products && products[prodIndex];
    const tag_label = product && product.details && product.details.title;
    const engagement_id = product && product.id;
    const engagement_data = parseJsonToFormData({
      product_id: engagement_id,
      product_label: tag_label,
    });
    const eventData = {
      event: 'gallery_interaction',
      event_type: 'collection_product',
      engagement_id,
      engagement_type: 'in-video',
      tag_label,
      engagement_label: tag_label,
      engagement_data,
    };
    this.props.logDataEvent(eventData);
  };

  logCommerceEvent = () => {
    let engagements = getEngagements(this.props.tag);
    let action = engagements && engagements[0];
    let actionLabel = action[`label|${action.slug}`];
    let actionValueFormtted = action.slug;

    let tag_id = this.props.tag.id;
    let tag_label =
      this.props.tag &&
      this.props.tag.details &&
      (this.props.tag.details.preview_title || this.props.tag.details.title);
    let engagement_id = action && action.id;
    let engagement_label = actionLabel;

    let logDataObj = {
      type: actionValueFormtted,
      sub_type: null,
      event: 'gallery_interaction',
      event_type: actionValueFormtted,
      tag_id,
      tag_label,
      engagement_id,
      engagement_label,
      current_duration: this.props.getCurrentTime(),
    };

    this.props.logDataEvent(logDataObj);
  };

  handleSlideChange = (e) => {
    e && e.stopPropagation();
    // console.log(this.swiper.activeIndex);
    const isCollectionsTag = this.checkForCollectionType();
    if (isCollectionsTag) {
      const activeProdIdx = this.swiper.activeIndex;
      this.updateEngagement(activeProdIdx);
      // collection interaction event---
      this.logCollectionsEvent(this.swiper.activeIndex);
    } else {
      this.logCommerceEvent();
    }
    this.setSliderArrows();
  };

  initializeSwiper() {
    let autoplay =
      this.props.config_data_json &&
      this.props.config_data_json.abConfig &&
      this.props.config_data_json.abConfig.productSliderAutoslide;
    if (autoplay && typeof autoplay === 'object') {
      autoplay = autoplay;
    } else {
      autoplay = !!autoplay;
    }

    let options = Object.assign(
      {},
      {
        speed: 300,
        initialSlide: this.state.activeIndex || 0,
        slidesPerView: 1,
        observer: true,
        observerParents: true,
        nested: true,
        autoplay: autoplay,
      }
    );

    if (this.state.swiperJS && this.swiperContainer) {
      if (this.swiper) {
        this.swiper.off('slideChangeTransitionEnd', this.handleSlideChange);
        this.swiper.destroy();
      }

      this.swiper = new Swiper(this.swiperContainer, options);
      this.swiper.on('slideChangeTransitionEnd', this.handleSlideChange);
      this.setSliderArrows();
    }
  }

  setSliderArrows() {
    if (this.swiper) {
      const { isEnd, isBeginning } = this.swiper;
      this.setState({
        isBeginning,
        isEnd,
      });
    }
  }

  checkForSwiper = () => {
    return new Promise((resolve, reject) => {
      if (!window.Swiper) {
        this.loadSwiperJS = loadJS(swiperJS, HEAD);
        this.loadSwiperCSS = loadCSS(swiperCSS, HEAD);

        Promise.all([this.loadSwiperJS, this.loadSwiperCSS]).then((res) => {
          this.setState(
            {
              swiperJS: true,
            },
            () => {
              resolve();
            }
          );
        });
      } else {
        this.setState(
          {
            swiperJS: true,
          },
          () => {
            resolve();
          }
        );
      }
    });
  };

  nextSlide = (e) => {
    this.swiper && this.swiper.slideNext();
    this.setSliderArrows();
    // this.handleSlideChange();
    e && e.stopPropagation();
  };

  prevSlide = (e) => {
    this.swiper && this.swiper.slidePrev();
    // this.handleSlideChange();
    this.setSliderArrows();
    e && e.stopPropagation();
  };

  handleResize = () => {
    this.initializeSwiper();
  };
}



// WEBPACK FOOTER //
// ./components/skinV3ProductShowcase/index.js